<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newMode">Create New Customer Log Type</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Customer Log Type</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Customer Log Type</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  :label="labels.logType"
                  v-model="form.logType"
                  :error-messages="errors.collect('logType')"
                  data-vv-name="logType"
                  :data-vv-as="labels.logType"
                  v-validate="'required|max:4'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.logType }}</v-subheader>
                <div class="queryValue">{{ form.logType }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <v-text-field
                  v-model="form.logTypeDesc"
                  :label="labels.logTypeDesc"
                  :error-messages="errors.collect('form.logTypeDesc')"
                  data-vv-name="form.logTypeDesc"
                  :data-vv-as="labels.logTypeDesc"
                  v-validate="'required|max:35'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.logTypeDesc }}</v-subheader>
                <div class="queryValue">{{ form.logTypeDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-checkbox class="queryValue" v-model="form.permitUw" style="display: inline-block" disabled>{{ form.permitUw }}</v-checkbox>
                <v-subheader class="queryLabel" style="display: inline-block">{{ labels.permitUw }}</v-subheader>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <v-checkbox :label="labels.permitUw" v-model="form.permitUw"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="reviewMode">
                <v-checkbox class="queryValue" v-model="form.permitUw" style="display: inline-block">{{ form.permitUw }}</v-checkbox>
                <v-subheader class="queryLabel" style="display: inline-block">{{ labels.permitUw }}</v-subheader>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-checkbox class="queryValue" v-model="form.permitCl" style="display: inline-flex" disabled>{{ form.permitCl }}</v-checkbox>
                <v-subheader class="queryLabel" style="display: inline-flex; text-align: center">{{ labels.permitCl }}</v-subheader>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <v-checkbox :label="labels.permitCl" v-model="form.permitCl"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="reviewMode">
                <v-checkbox class="queryValue" v-model="form.permitCl" style="display: inline-block">{{ form.permitCl }}</v-checkbox>
                <v-subheader class="queryLabel" style="display: inline-block">{{ labels.permitCl }}</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-spacer class="mt-3"></v-spacer>
          <v-layout>
            <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
              Cancel
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
              Save
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      disabled: true,
      toogleArray: [false],
      submitting: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      labels: {
        logType: 'Log Type',
        logTypeDesc: 'Description',
        permitUw: 'Permit in Underwriting',
        permitCl: 'Permit in Claims',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        logType: null,
        logTypeDesc: null,
        permitUw: false,
        permitCl: false,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      loading: true,
      today: new Date()
    }
  },
  computed: {
    menu() {
      return this.$store.state.custLogTypeParam.menu
    },
    newLogType() {
      return this.logTypeId.tranMode === 'New'
    },
    logTypeId() {
      return this.$store.state.custLogTypeParam.logType.logTypeId
    }
  },
  methods: {
    async doInit() {
      if (this.newLogType) {
        this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.form.createdDate = new Date()
      } else {
        this.fetchData(true)
      }
    },
    async fetchData() {
      const apiURI = this.menu.getCustLogType
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            logType: this.logTypeId.logType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.logType = data.custLT.logType
            this.form.logTypeDesc = data.custLT.logTypeDesc
            this.form.permitUw = data.custLT.permitUw
            this.form.permitCl = data.custLT.permitCl
            this.form.createdBy = data.createdBy
            this.form.createdDate = data.createdDate
            this.form.modifiedBy = data.modifiedBy
            this.form.modifiedDate = data.modifiedDate
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'custLogType' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newLogType) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else if (this.newMode) {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createCustLogType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'custLogType' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateCustLogType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'custLogType' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    formatDisplayDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('logType'))
    this.$store.commit('CUSTLOGTYPE_COMMIT_KEY', jsonData)
    if (this.logTypeId.tranMode !== '') {
      if (this.logTypeId.tranMode === 'New') {
        this.newMode = true
      } else if (this.logTypeId.tranMode === 'Review') {
        this.reviewMode = true
      } else if (this.logTypeId.tranMode === 'Query') {
        this.queryMode = true
      }
    }

    this.form.permitUw = this.logTypeId.permitUw === 'true'
    this.form.permitCl = this.logTypeId.permitCl === 'true'
  },
  mixins: [MessageMixin]
}
</script>
